import {
  PublicSharedUserApi,
  PublicSharedUserApi$ResetPasswordInput,
} from "@/custolink-transpiled_by_server/bc.identity_and_access.api_methods";
import React, { useEffect, useState } from "react";
import Button from "@/components/ui/Button";
import useFormServerBacked from "@/custolink-hooks/form/useFormServerBacked";
import useFormErrorPicker from "@/custolink-hooks/form/useFormErrorPicker";
import useUiContext from "@/custolink-hooks/useUiContext";
import Form from "../../components/ui/Form/Form";
import { Controller } from "react-hook-form";
import PasswordInput from "../../components/shared/PasswordInput";
import FormItem from "@/components/ui/Form/FormItem";

export default function ResetPasswordSharedForm(p: {
  token: string;
  onDone: () => void;
  /**
   * This component is shared between the admin area (admin/auth/ResetPasswordForUser.tsx)
   * and the customer-facing one (end_user/ResetPasswordForEndUser.tsx) - it cannot tell which
   * side it is on by itself, so the caller says. Admin-area callers leave this unset; the
   * end_user caller passes "asset" so its validation toast follows the asset-frontend switch.
   */
  toastDesignSwitch?: "admin" | "asset";
}) {
  const uic = useUiContext();
  const [repeatError, setRepeatError] = useState<boolean>(false);
  const form = useFormServerBacked<
    PublicSharedUserApi$ResetPasswordInput & { repeatPassword: string }
  >(
    {},
    (d) => {
      if (d.newPassword != d.repeatPassword) {
        if(d.newPassword.length > 0){
          setRepeatError(true);
        }
        return Promise.reject();
      } else {
        setRepeatError(false);
        return PublicSharedUserApi.resetPassword(d);
      }
    },
    () => {
      p.onDone();
    },
    undefined,
    p.toastDesignSwitch,
  );

  useEffect(() => {
    form.reset({ organisationId: uic._orgId, newPassword: "", token: p.token });
  }, [p.token]);

  const e = useFormErrorPicker(form.errors, "newPassword");

  return (
    <div>
      <Form onSubmit={form.handleSubmit()}>
        <FormItem
          label="New Password"
          invalid={e.newPassword != null}
          errorMessage={e.newPassword}
        >
          <Controller
            name="newPassword"
            control={form.control}
            render={({ field }) => (
              <PasswordInput
                autoComplete="off"
                placeholder="••••••••••••"
                {...field}
              />
            )}
          />
        </FormItem>
        <FormItem
          label="Repeat Password"
          invalid={repeatError}
          errorMessage={repeatError ? "Passwords do not match" : undefined}
        >
          <Controller
            name="repeatPassword"
            control={form.control}
            render={({ field }) => (
              <PasswordInput
                autoComplete="off"
                placeholder="Confirm Password"
                {...field}
              />
            )}
          />
        </FormItem>
        <Button
          block
          disabled={!form.isDirty}
          loading={form.isSubmitting}
          variant="solid"
          type="submit"
        >
          {form.isSubmitting ? "Submiting..." : "Submit"}
        </Button>
      </Form>
    </div>
  );
}
